
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
// import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Link } from "routes";
import Grid from '@material-ui/core/Grid';
import Lazyload from 'react-lazyload';

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    authorName: {
        fontSize: 14,
        paddingTop: 8
    },    
    authorTitle: {
        fontSize: 12,
    },
    bigAvatar: {
        width: 60,
        height: 60,
    },
});

function AuthorCard(props) {
  const { classes, item } = props;
  let authorEmail = item && item.email ? item.email : 'noprofile';
  let authorSlug = item && item.slug ? item.slug : authorEmail;
  return (
      
    <Grid item md={4} sm={6} xs={12} >
        <List className={classes.root}>
            <Paper elevation={1} style={{margin: '0px 14px'}}>
                {/* <Link route="authorProfile" onClick={e => e.preventDefault()} params={{ id: authorSlug }}> */}
                    <span className="anchor-link">
                        <ListItem alignItems="flex-start">
                            <ListItemAvatar>
                                <Lazyload height={100} offset={200} once>
                                    <Avatar alt={item.name} className={classes.bigAvatar} src={item.profile_pic} />
                                </Lazyload>
                            </ListItemAvatar>
                            <ListItemText
                                classes={{
                                    primary: classes.authorName,
                                    secondary: classes.authorTitle
                                }}                            
                                primary={item.name}
                                secondary={item.title}
                                // secondary={
                                //     <React.Fragment>
                                //     <Typography component="span" className={classes.inline} color="textPrimary">
                                //         {item.title}
                                //     </Typography>
                                //     </React.Fragment>
                                // }
                            />
                        </ListItem>
                    </span>
                {/* </Link> */}
            </Paper>
            
        </List>
    </Grid>
  );
}

AuthorCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthorCard);
